// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".entity_list_link_title-module__title--38mii{font-weight:600;font-size:16px;line-height:24px;letter-spacing:0px;cursor:pointer}.entity_list_link_title-module__title--38mii:hover{text-decoration:underline}\n", ""]);
// Exports
exports.locals = {
	"title": "entity_list_link_title-module__title--38mii"
};
module.exports = exports;
